import React from "react";
import Dialog from "@material-ui/core/Dialog";
import { DialogContentWithCards } from "../components/DialogContent";
import { TextLabel } from "../components/TextLabel";
import { DialogTitle } from "../components/DialogTitle";
import { Progress } from "../components/Progress";
import Typography from "@material-ui/core/Typography";
import SimpleTable from "../components/SimpleTable";
import { PaperCard } from "../components/PaperCard";
import Grid from "@material-ui/core/Grid";
import OrganizationName from "../containers/OrganizationName";
import { GlobalAccessCheckbox } from "../components/GlobalAccessCheckbox";

export const AppBundleInfoDialog = ({
  onClose,
  onEdit,
  onDelete,
  appBundle: { name, description, doNotDelete, organizationRef, globalAccess },
  apps: { managedApps, externalApps },
  loading
}) => {
  const headers = ["", "Title", "Package Name", "VR Type(s)"];
  return (
    <Dialog maxWidth="lg" scroll="body" onClose={onClose} open spacing={0}>
      <DialogTitle
        onEdit={onEdit}
        onDelete={onDelete}
        darkBg
        doNotDelete={doNotDelete}
        organizationRef={organizationRef}
      >
        App Bundle: {name}
      </DialogTitle>
      <DialogContentWithCards>
        <Grid container spacing={3}>
          {loading && <Progress />}

          <Grid item xs={12}>
            <PaperCard>
              <TextLabel label="Name" value={name} />
              <TextLabel label="Description" value={description} multiline />
              <OrganizationName organizationRef={organizationRef} />
              <GlobalAccessCheckbox value={globalAccess} readonly />
            </PaperCard>
          </Grid>

          <Grid item xs={12}>
            <PaperCard>
              <Typography variant="subtitle1">
                <b>Managed Apps</b>
              </Typography>
              <SimpleTable headers={headers} rows={managedApps} />
            </PaperCard>
          </Grid>

          <Grid item xs={12}>
            <PaperCard>
              <Typography variant="subtitle1">
                <b>External Apps</b>
              </Typography>
              <SimpleTable headers={headers} rows={externalApps} />
            </PaperCard>
          </Grid>
        </Grid>
      </DialogContentWithCards>
    </Dialog>
  );
};
